import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button"]

  connect() {
    console.log("LoadingState controller connected to form", this.element)
  }

  // Called when the form submission starts
  submitStart(event) {
    console.log("LoadingState: submitStart triggered", event)
    const button = this.buttonTarget
    const [defaultIcon, loadingIcon] = button.children
    defaultIcon.classList.add("hidden")
    loadingIcon.classList.remove("hidden")
  }

  // Called when the form submission ends
  submitEnd(event) {
    console.log("LoadingState: submitEnd triggered", event)
    const button = this.buttonTarget
    const [defaultIcon, loadingIcon] = button.children
    defaultIcon.classList.remove("hidden")
    loadingIcon.classList.add("hidden")
  }
} 